import { createFloatingRegistry } from 'hooks/useFloatingRegistry';

const { Context: DealerChipContext, Provider: DealerChipProvider } =
  createFloatingRegistry<number>('DealerChip');

export default DealerChipContext;
export { DealerChipProvider };
